import { ILegacyCartEntry } from '@rbi-ctg/menu';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { LoyaltyAppliedOffer } from 'state/loyalty/types';

import { IAppliedRewards, ICartEntryAdapter, IEntriesIdsMap } from '../types';

// Creates a flat map of all cart entries with sanityId property as key
export const flattenEntriesToMap: (
  acc: IEntriesIdsMap,
  entry: ICartEntryAdapter
) => IEntriesIdsMap = (acc: IEntriesIdsMap, entry: ICartEntryAdapter) => ({
  ...acc,
  [entry.sanityId]: true,
  ...entry.children?.reduce(flattenEntriesToMap, {}),
});

// Function maps from ILegacyCartEntry to ICartEntryAdapter to send entries to BE
// Also filters entries that have a reward applied

export const parseEntry = ({
  type,
  incentivesToExclude,
}:
  | { type: LoyaltyPromotionType.OFFER; incentivesToExclude?: IAppliedRewards }
  | { type: LoyaltyPromotionType.REWARD; incentivesToExclude?: LoyaltyAppliedOffer[] }) => {
  return (
    acc: ICartEntryAdapter[],
    { _id, cartId, price = 0, quantity = 1, children }: ILegacyCartEntry
  ) => {
    if (type === LoyaltyPromotionType.OFFER) {
      const rewardApplied = incentivesToExclude?.[cartId];
      if (rewardApplied?.timesApplied === quantity) {
        return acc;
      }
    } else if (type === LoyaltyPromotionType.REWARD) {
      const offerApplied = incentivesToExclude?.find(offer => offer.cartId === cartId);

      if (offerApplied) {
        return acc;
      }
    }

    const parsed: ICartEntryAdapter = {
      sanityId: _id,
      lineId: cartId,
      price,
      quantity,
    };
    if (children.length) {
      parsed.children = children.reduce(
        //@ts-ignore - type and incentivesToExclude will always be compatible
        parseEntry({ type, incentivesToExclude }),
        []
      );
    }
    return [...acc, parsed];
  };
};
